import { FALLBACK_NODE_COLOR, NODE_BORDER_RADIUS } from '../constants.js';
import type { SankeyLayoutNode } from '../types/sankey-internal.js';

export function drawNodes(
  ctx: CanvasRenderingContext2D,
  nodes: SankeyLayoutNode[],
  nodeColors: Map<string, string>,
): void {
  for (const node of nodes) {
    if (
      node.x0 === undefined ||
      node.x1 === undefined ||
      node.y0 === undefined ||
      node.y1 === undefined
    ) {
      continue;
    }

    ctx.fillStyle = nodeColors.get(node.id) ?? FALLBACK_NODE_COLOR;
    ctx.beginPath();
    ctx.roundRect(
      node.x0,
      node.y0,
      node.x1 - node.x0,
      node.y1 - node.y0,
      NODE_BORDER_RADIUS,
    );
    ctx.fill();
  }
}
